import { UnifiedAlarm } from '@hakimo-ui/hakimo/types';
import useAuthenticatedRequest from '../shared/useAuthenticatedRequest';

export function useScanRawAlarms(eventId: string) {
  const host = window.location.hostname;
  const baseUrl =
    host === 'localhost'
      ? `http://${host}:${window.location.port}`
      : `https://event-flow-${host}`;

  const url = `${baseUrl}/api/events/${eventId}`;
  const request = new Request(url);

  return useAuthenticatedRequest<UnifiedAlarm>(request, {
    queryKey: ['scan_raw_alarm', eventId],
    responseModifier: async (response) => {
      const respJson = await response.json();
      return respJson.payload;
    },
  });
}

export default useScanRawAlarms;
